import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { formatUSPhone, handleUSPhoneChange } from '../../utils/phoneFormatter';
import { useUSPhoneValidation } from '../../hook/useUSPhoneValidation';
import { delete_LeadershipGroupByLeadershipId, getLeadership, getleadershipGroupsMappingByGroupId, post_LeadershipGroupMapping, put_Leadership } from '../../services/Leadership';
import baseURL from '../../config/api';
import axios from 'axios';
import useAuth from '../../hook/useAuth';
import useConfirm from '../../hook/useConfirm';
import { getleadershipGroupsByGroupId } from '../../services/LeadershipGroup';
import Select from "react-select";
import useGroup from '../../hook/useGroup';
import EmailFormatValidation from '../../components/EmailFormatValidation';
import Cookies from 'js-cookie';

const EditLeadership = () => {
    const token = Cookies.get("token-my-cdir");
    const { selectedGroupId, isSuperAdmin }: any = useGroup();
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { id }: any = useParams();
    const [leadershipData, setLeadershipData] = useState<any>({
        groupId: 0,
        firstName: "",
        lastName: "",
        designation: "",
        email: "",
        phoneNumber: "",
        imageUrl: "",
        order: 0,
    });
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [isImageUploading, setIsImageUploading] = useState<boolean>(false);
    const {
        isValid: isPhoneValid,
        touched: phoneTouched,
        setTouched: setPhoneTouched
    } = useUSPhoneValidation(leadershipData.phoneNumber);
    const [leadershipGroups, setLeadershipGroups] = useState<any[]>([]);
    const [leadershipGroupIds, setLeadershipGroupIds] = useState<any>(null);
    const [leadershipGroupDataIsLoaded, setLeadershipGroupDataIsLoaded] = useState<boolean>(false);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [isRefreshTheLeadershipGroupIds, setIsRefreshTheLeadershipGroupIds] = useState<boolean>(false);

    useEffect(() => {
        if (selectedGroupId) {
            if (isRefreshTheLeadershipGroupIds) setLeadershipGroupIds("");
            getleadershipGroupsByGroupId(selectedGroupId, token!.toString())
                .then(res => {
                    setLeadershipGroups(res.map((item: any) => {
                        return {
                            value: item?.id,
                            label: item?.name
                        }
                    }));

                    setLeadershipGroupDataIsLoaded(true);
                })
                .catch(error => {
                    console.log(error);
                    setLeadershipGroupDataIsLoaded(true);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId])

    useEffect(() => {
        if (id && isFirstTime && leadershipGroupDataIsLoaded) {
            getleadershipGroupsMappingByGroupId(id, token!.toString())
                .then(res => {
                    const ids = res?.map((item: any) => ({
                        value: item?.leadershipGroupId,
                        label: item?.leadershipGroupName || ""
                    }));

                    setLeadershipGroupIds(ids);
                    setIsFirstTime(false);
                    setIsRefreshTheLeadershipGroupIds(true);
                })
                .catch(error => {
                    setIsFirstTime(false);
                    setIsRefreshTheLeadershipGroupIds(true);
                    console.error(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, leadershipGroupDataIsLoaded])

    useEffect(() => {
        if (id) {
            getLeadership(id, token!.toString())
                .then(res => {
                    setLeadershipData({
                        id: res.id,
                        firstName: res.firstName,
                        lastName: res.lastName,
                        designation: res.designation,
                        email: res.email,
                        phoneNumber: res.phoneNumber,
                        imageUrl: res.imageUrl,
                        order: res.order
                    });

                    setPhoneTouched(false);
                })
                .catch(error => console.error(error));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const closeModal = () => navigate(-1);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isProcessing) {
            setIsProcessing(true);

            put_Leadership({
                ...leadershipData,
                groupId: selectedGroupId
            }, auth?.id, token!.toString())
                .then(async () => {
                    await delete_LeadershipGroupByLeadershipId(id, auth?.id, token!.toString())
                        .catch(error => {
                            console.error(error);
                        })

                    if ((Array.isArray(leadershipGroupIds) && leadershipGroupIds?.length > 0)) {
                        const ids = leadershipGroupIds?.map((item: any) => ({
                            leadershipId: id,
                            leadershipGroupId: item?.value
                        }));

                        post_LeadershipGroupMapping(ids, auth?.id, token!.toString())
                            .then(() => {
                                setIsProcessing(false);
                                navigate(-1);
                            })
                            .catch(error => {
                                console.error(error);
                            })
                    } else {
                        setIsProcessing(false);
                        navigate(-1);
                    }
                })
                .catch(error => {
                    setIsProcessing(false);
                    console.error(error);
                    setConfirmData({
                        title: "Warning",
                        summary: error?.response?.data,
                        confirmBtn: "Ok",
                        isCancelBtn: true,
                        isConfirm: (cb: any) => {
                            cb();
                        }
                    });
                    setConfirmPopup(true);
                });
        }
    }

    const inputFileRef = useRef<HTMLInputElement>(null);
    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsImageUploading(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token?.toString()}`
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    setLeadershipData({ ...leadershipData, imageUrl: response.data });
                    setIsImageUploading(false);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

        } else {
            setIsImageUploading(false);
        }
    };

    return (
        <div className="w-full">
            <div className="my-2">
                <div className="py-8 px-6 relative bg-white">
                    <h2 className="text-xl text-secondary font-bold">Edit Leadership</h2>
                    <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">
                        <div className="w-full text-sm">
                            <label htmlFor="churchImage" className="w-full text-start block text-secondary font-semibold text-sm">
                                Leadership Image
                            </label>

                            {isImageUploading ? (
                                <div className="ml-2 mt-2 text-xs text-secondary flex items-center">
                                    <svg className="animate-spin mr-2" width="16" height="16">...</svg>
                                    Uploading...
                                </div>
                            ) : !leadershipData?.imageUrl ? (
                                <div className="flex items-center ml-2 mt-2">
                                    <label
                                        className="text-white bg-secondary text-xs cursor-pointer p-2 rounded"
                                        onClick={() => {
                                            if (inputFileRef.current !== null) {
                                                inputFileRef.current.click();
                                            }
                                        }}
                                    >
                                        Add Image
                                    </label>
                                </div>
                            ) : (
                                <div className="flex items-center ml-2 mt-2">
                                    <img
                                        src={`${baseURL}commonFile/Get?name=${leadershipData?.imageUrl}`}
                                        width={100}
                                        height={80}
                                        alt="churchImage"
                                        className="mr-3"
                                    />

                                    <label
                                        className="text-white bg-red-500 text-xs cursor-pointer px-3 py-2 rounded"
                                        onClick={() => setLeadershipData({ ...leadershipData, imageUrl: "" })}
                                    >
                                        Delete
                                    </label>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                name="churchImage"
                                ref={inputFileRef}
                                onChangeCapture={onFileChangeCapture}
                                className="hidden"
                            />
                        </div>

                        {!isSuperAdmin && <div />}

                        <div className="">
                            <label htmlFor="firstname" className="w-full text-start block text-secondary font-semibold text-sm">Leadership Team</label>
                            <Select
                                isMulti
                                className="basic-single mt-3"
                                classNamePrefix="select"
                                isDisabled={false}
                                isLoading={false}
                                isClearable={false}
                                isRtl={false}
                                isSearchable={false}
                                name="subGroups"
                                value={leadershipGroupIds}
                                onChange={(value) => setLeadershipGroupIds(value)}
                                options={leadershipGroups}
                            />
                        </div>

                        {!isSuperAdmin && <div className='max-xm:hidden' />}

                        <div>
                            <label className="font-semibold text-sm">First Name</label>
                            <input type='text' placeholder='Enter First Name'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={leadershipData.firstName}
                                onChange={(e) => setLeadershipData({ ...leadershipData, firstName: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Last Name</label>
                            <input type='text' placeholder='Enter Last Name'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={leadershipData.lastName}
                                onChange={(e) => setLeadershipData({ ...leadershipData, lastName: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Designation</label>
                            <input type='text' placeholder='Enter Designation'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={leadershipData.designation}
                                onChange={(e) => setLeadershipData({ ...leadershipData, designation: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Phone Number</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formatUSPhone(leadershipData.phoneNumber)}
                                onChange={(e) => {
                                    setPhoneTouched(true);
                                    handleUSPhoneChange(e, (digits) =>
                                        setLeadershipData((prev: any) => ({
                                            ...prev,
                                            phoneNumber: digits,
                                        }))
                                    );
                                }}
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                placeholder="Enter Phone No."
                            />

                            {!isPhoneValid && phoneTouched && (
                                <p className="text-xs text-red-500 mt-1">
                                    Please enter a valid 10-digit phone number
                                </p>
                            )}
                        </div>

                        <EmailFormatValidation
                            text={leadershipData.email}
                            setText={(value) =>
                                setLeadershipData({
                                    ...leadershipData,
                                    email: value
                                })
                            }
                            className={{
                                parentDiv: "",
                                label: "font-semibold text-sm",
                                input:
                                    "w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                            }}
                            required
                        />

                        <div>
                            <label className="font-semibold text-sm">Order</label>
                            <input type='number' placeholder="Enter Order"
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={leadershipData.order}
                                onChange={(e) => setLeadershipData({ ...leadershipData, order: e.target.value })}
                                required
                            />
                        </div>

                        <div className="flex max-xm:flex-col gap-4 !mt-4">
                            <button
                                type="button"
                                className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                            >
                                {isProcessing ?
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                                            viewBox="0 0 26.349 26.35">
                                            <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                                            <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                                            <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                                            <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                                            <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                                            <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                                            <path
                                                d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                                                data-original="#000000" />
                                            <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                                        </svg>
                                        Processing...
                                    </>
                                    :
                                    "Save"
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default EditLeadership